<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      v-b-modal.form-leave-quota-modal
      @click="cleanUpForm()"
    >
      Tambah
    </b-button>

    <b-modal
      id="form-leave-quota-modal"
      no-close-on-backdrop
      size="lg"
      title="Tambah Kuota Cuti Karyawan'"
    >
      <validation-observer ref="leaveQuotaValidation">
        <div class="form">
          <div class="row">
            <div class="col-7">


                    

              


            </div>
          </div>
        </div>
      </validation-observer>

      <template #modal-footer="{}">
        <div v-if="isLoadingGlobalHoliday">
          <br />
          <b-spinner class="mb-2" variant="primary" /><br />
        </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingGlobalHoliday"
          @click="submitItem()"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    formPayload: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    editId: {
      type: Number,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    validations: {
      type: "",
    },
    cleanUpForm: {
      type: Function,
    },
    type: {
      type: "",
    },
    period: {
      type: "",
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      parents: [],
      isLoadingGlobalHoliday: false,
      formPayloadPaidLeave: {
        category: 0,
        expiredDate: "",
        isActive: true,
        noLimit: true,
        rules: 0,
        startDate: "",
        totalPaidLeave: 0
      },
      booleanList: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
      typeList: [],
      periodList: [],
      showDate: true
    };
  },
  watch: {
    isLoading(value) {
      this.isLoadingGlobalHoliday = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadPaidLeave = value;
      },
      deep: true,
    },
    formPayloadPaidLeave: {
      handler(value) {
        this.$emit("payloadPaidLeave", value);
      },
      deep: true,
    },
    type(value) {
      this.typeList = value;
    },
    period(value) {
      this.periodList = value;
    },
    'formPayloadPaidLeave.noLimit': function(value) { 
      if (value == true) {
        return this.showDate  =   'required'
      }
      return this.showDate  =   ''
    },
  },
  methods: {
    submitItem() {
      this.$refs.leaveQuotaValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
